export default function matchAll(str, regexp) {
    if (!str) {
        return [];
    }
    const matches = [];
    str.replace(regexp, (...args) => {
        const arr = ([]).slice.call(args, 0);
        const [index, input] = arr.splice(-2);
        arr.index = index;
        arr.input = input;
        matches.push(arr);
    });
    return matches.length ? matches : [];
}
